<template>
  <div>
    <div
      id="main-sidebar"
      class="ui sidebar visible small inverted blue labeled vertical icon menu"
    >
      <router-link
        :to="{ name: 'bizlibrary-content' }"
        class="item"
        :class="{ 'disabled active': isActive(contentListNames) }"
        data-content="Browse Content"
      >
        <i class="large bzl-browse-content icon"></i>
        <p>Browse Content</p>
      </router-link>
      <router-link
        :to="{ name: 'custom-content' }"
        class="item"
        :class="{ 'disabled active': isActive(myContentNames) }"
        data-content="My Custom Content"
        v-if="canCustomizeContent"
      >
        <i class="large bzl-my-custom-content icon"></i>
        <p>My Custom Content</p>
      </router-link>
      <router-link
        v-if="isProductUnlimited"
        :to="{ name: 'content-queue' }"
        class="item"
        :class="{ 'disabled active': isActive(['content-queue']) }"
        data-content="Queue"
      >
        <i class="large bzl-cloud-outline icon">
          <div class="ui pink floating small label" v-if="showSelectedNum">
            {{ selectedItems.length }}
          </div>
        </i>
        <p>Queue</p>
      </router-link>
      <router-link
        v-if="!isProductUnlimited"
        :to="{ name: 'my-activations' }"
        class="item"
        :class="{ 'disabled active': isActive(['my-activations']) }"
        data-content="My Activations"
      >
        <i class="large bzl-my-activations icon"></i>
        <p>My Activations</p>
      </router-link>
      <router-link
        :to="{ name: 'content-log' }"
        class="item"
        :class="{ 'disabled active': isActive(['content-log']) }"
        data-content="Content Log"
      >
        <i class="large bzl-history icon"></i>
        <p>Content Log</p>
      </router-link>
      <div
        class="item disabled"
        :class="{ 'active pink': isActive(contentProfileNames) }"
        v-if="canCustomizeContent"
      >
        <i class="large icon bzl-edit-outline"></i>
        <p>Content Editor</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NavSidebar',
  data() {
    return {
      sidebar: false,
      contentProfileNames: [
        'custom-content-details',
        'custom-content-support-materials',
        'custom-content-interactions',
        'custom-content-quiz',
        'custom-content-captions',
        'custom-quiz-details',
        'custom-quiz-questions',
      ],
      contentListNames: [
        'content-list',
        'content-grid',
        'content-list-preview',
      ],
      myContentNames: ['custom-content-list', 'custom-content-list-preview'],
      isHovered: false,
      otsContentImg: require('@/assets/browse-content.svg'),
      customContentImg: require('@/assets/my-custom-content.svg'),
    };
  },
  computed: {
    ...mapGetters(['canCustomizeContent', 'isProductUnlimited']),
    selectedItems() {
      return this.$store.getters.downloadQueue.ots.concat(this.$store.getters.downloadQueue.custom);
    },
    showSelectedNum() {
      return this.selectedItems.length > 0;
    },
  },
  methods: {
    isActive(names) {
      return names.indexOf(this.$route.name) > -1;
    },
  },
};
</script>

<style lang="less" scoped>
.item:first-child {
  margin-top: 2.85rem;
}
div.add-content-button {
  position: absolute;
  top: 70px;
  z-index: 9999;
  left: 65px;
}
i.bzl-cloud-outline {
  position: relative;
}
.ui.icon.button.green {
  span {
    margin-left: 0.5em;
  }
}
.ui.sidebar {
  position: absolute;
}
.ui.inverted.icon.menu .item {
  width: 100px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
